export default __webpack_public_path__ + "static/media/rgs_mobile@2x.56189123.jpg";